import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Jumbotron = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,            // fade duration (ms)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        fade: true,            // enable fade transition
        cssEase: 'linear'      // optional: smoother fade
    };

    return (
        <div className="row">
            <div className="col-12 text-center p-0 h-fixed-70">
                <Slider {...settings}>
                    <div>
                        <img
                            src="/images/jumbotron-slider/hero_image_1.png"
                            alt="Slide 1"
                            className="img-fluid d-block d-sm-block d-md-block d-lg-none d-xl-none"
                        />
                        <img
                            src="/images/jumbotron-slider/hero_image_1_1.png"
                            alt="Slide 1"
                            className="img-fluid d-none d-sm-none d-md-none d-lg-block d-xl-block"
                        />
                    </div>
                    <div>
                        <img
                            src="/images/jumbotron-slider/hero_image_2.png"
                            alt="Slide 2"
                            className="img-fluid d-block d-sm-block d-md-block d-lg-none d-xl-none"
                        />
                        <img
                            src="/images/jumbotron-slider/hero_image_1_2.png"
                            alt="Slide 2"
                            className="img-fluid d-none d-sm-none d-md-none d-lg-block d-xl-block"
                        />
                    </div>
                    <div>
                        <img
                            src="/images/jumbotron-slider/hero_image_3.png"
                            alt="Slide 3"
                            className="img-fluid d-block d-sm-block d-md-block d-lg-none d-xl-none"
                        />
                        <img
                            src="/images/jumbotron-slider/hero_image_1_3.png"
                            alt="Slide 3"
                            className="img-fluid d-none d-sm-none d-md-none d-lg-block d-xl-block"
                        />
                    </div>
                    <div>
                        <img
                            src="/images/jumbotron-slider/hero_image_4.png"
                            alt="Slide 3"
                            className="img-fluid d-block d-sm-block d-md-block d-lg-none d-xl-none"
                        />
                        <img
                            src="/images/jumbotron-slider/hero_image_1_4.png"
                            alt="Slide 4"
                            className="img-fluid d-none d-sm-none d-md-none d-lg-block d-xl-block"
                        />
                    </div>
                </Slider>
                <div className='carousel-slide-caption'>
                    <div className='row justify-content-md-center justify-content-lg-center'>
                        <div className='col-12 col-md-7 col-lg-7 slider-caption-1'>
                            <h2>Where Smart Investment Starts</h2>
                            <p>Catalyst Business Partners (CBP) aims to provide curated, high-potential opportunities to members through a personalised, transparent and guided approach</p>
                        </div>
                    </div>
                    <div className='row justify-content-md-center justify-content-lg-center'>
                        <div className='col-12 col-md-7 col-lg-7 slider-caption-2'>
                            <div className='row'>
                                <div className='col-12 d-flex justify-content-center align-items-center'>
                                    <div className='j-box dek-vertical-border'>
                                        <h3>500+</h3>
                                        <p className='d-block d-sm-block d-md-none d-lg-none d-xl-none'>Active <br /> deals</p>
                                        <p className='d-none d-sm-none d-md-block d-lg-block d-xl-block'>Active deals</p>
                                    </div>
                                    <div className='j-box dek-vertical-border'>
                                        <h3>100Cr+</h3>
                                        <p className='d-block d-sm-block d-md-none d-lg-none d-xl-none'>Closed <br />deals</p>
                                        <p className='d-none d-sm-none d-md-block d-lg-block d-xl-block'>Closed deals</p>
                                    </div>
                                    <div className='j-box'>
                                        <h3>118Cr+</h3>
                                        <p className='d-block d-sm-block d-md-none d-lg-none d-xl-none'>Funds <br />Committed</p>
                                        <p className='d-none d-sm-none d-md-block d-lg-block d-xl-block'>Funds Committed</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Jumbotron;